import React from "react";
import AuthContext from "../../../contexts/AuthContext";
import PointsService from "../../../services/management/PointsService";
import RowField from "../../shared/row-field/RowField";
import TopUsersModal from "../top-users-modal/TopUsersModal";
import TopUsersStates, { TopUsersProps } from "./TopUsers.models";
import './TopUsers.scss';
import image from '../../../assest/images/content/ItemAvatar@3x.png';
import { StudentPointsDTO } from "../../../models/dtos/management/StudentPointsDTO";

export default class TopUsers extends React.PureComponent<
    TopUsersProps,
    TopUsersStates
> {

    pointsService: PointsService;
    static contextType = AuthContext;
    constructor(props: TopUsersProps) {
        super(props);
        this.state = { data: { topStudents: [], totalStudents: 0 }, personal: {}, openDetailsModal: false, selectedStudentId: '', selectedOrderId: 0, selectedPoint: 0,selectedName:'' };
        this.pointsService = new PointsService();
    }

    componentDidMount() {
        this.getPage();
        this.setState({ personal: this.context.userInformation.personal });
    }


    componentDidUpdate = () => {
        this.setState({ personal: this.context.userInformation.personal });

    }


    getPage = () => {
        let state = this;
        this.pointsService.topStudents().then(response => {
            let result: StudentPointsDTO[] = [];

            response.topStudents.filter(element => {
            let isDuplicate = result.filter(item => item.id === element.id)[0] === undefined;

                if (isDuplicate) {
                    result.push(element);
                }

            });

            state.setState({
                data: { topStudents: result, totalStudents: response.totalStudents }
            });
        })
    }

    openDetailsModal = (selectedStudentId: string, point: number, orderId: number,name:string) => {
        this.setState({ selectedStudentId: selectedStudentId, selectedOrderId: orderId, selectedPoint: point,selectedName:name, openDetailsModal: true })
    }

    render(): React.ReactNode {
        let { data, personal, openDetailsModal, selectedStudentId, selectedOrderId, selectedPoint,selectedName } = this.state;

        return (
            <>
                <div className="top-users-area">
                    <div className="mt-3 text-right">
                        <label>شما</label>
                    </div>

                    {data.topStudents.filter(student => student.id === personal.id).map((student, key) => {
                        return <div key={key} className="col-md-12 col-12 col-lg-4 p-0 pb-3 " >
                            <div className="book-marked-banner word-list" onClick={() => this.openDetailsModal(student.id, student.point, student.orderId,student.studentFullName)}>
                                <div className="row">
                                    <div className="col-6">
                                        <label className="title mt-3">{student.studentFullName}</label>
                                    </div>
                                    <div className="col-6">
                                        <label className="details mt-2">امتیاز: {student.point}</label>
                                        <label className="details">رتبه: {student.orderId}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })}
                    <div className="total-student ">
                        <label>رتبه ی شما از بین <b>{data.totalStudents}</b> نفر</label>
                    </div>
                    {data.topStudents.map((student, key) => {
                        return <div key={key} onClick={() => this.openDetailsModal(student.id, student.point, student.orderId,student.studentFullName)}>
                            <RowField key={key} details={{ title: student.studentFullName, subTitle: '', imageSource: image, showButton: true, buttonText: student.point.toString() }} children={<>
                                <label className="student-rank" >{student.orderId}</label>
                            </>} wordRestrictionLeghnt={25} />
                        </div>
                    })}

                </div>
                <TopUsersModal name={selectedName} orderId={selectedOrderId} point={selectedPoint} studentId={selectedStudentId} showModal={openDetailsModal} closeModal={() => this.setState({ openDetailsModal: false })} />
            </>
        );
    }
}
